import { render } from "./indexAppointment.vue?vue&type=template&id=649f1039"
import script from "./indexAppointment.vue?vue&type=script&lang=js"
export * from "./indexAppointment.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__